// extracted by mini-css-extract-plugin
export default {"wrap":"Stage_wrap__GeNWy","empty":"Stage_empty__B6rR6"};